/* src/app/builder-screen-beta/components/smart-column-builder/smart-column-builder.component.scss */
.modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
}
.modal-title i {
  font-size: 24px;
}
.input-step,
.preview-step {
  padding: 16px 0;
}
.quick-templates {
  margin: 20px 0;
}
.quick-templates h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
}
.quick-templates h4 i {
  color: #faad14;
}
.quick-templates .template-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.quick-templates .template-buttons button {
  flex: 0 0 auto;
}
.json-textarea {
  font-family:
    "Consolas",
    "Monaco",
    "Courier New",
    monospace;
  font-size: 13px;
  line-height: 1.6;
  background-color: #f5f5f5;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 12px;
}
.json-textarea:focus {
  border-color: #1890ff;
  background-color: #ffffff;
}
.action-buttons {
  margin-top: 24px;
}
.action-buttons button {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
}
.preview-step nz-alert {
  margin-bottom: 20px;
}
.quick-actions {
  display: flex;
  gap: 8px;
  margin: 16px 0;
  justify-content: flex-start;
}
.columns-list {
  max-height: 450px;
  overflow-y: auto;
  padding: 8px 0;
  margin: 16px 0;
}
.columns-list::-webkit-scrollbar {
  width: 8px;
}
.columns-list::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}
.columns-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 4px;
}
.columns-list::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
.column-card {
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  border-radius: 8px;
}
.column-card:hover {
  border-color: #40a9ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
  transform: translateY(-2px);
}
.column-card.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
}
.column-card-content {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.column-info {
  flex: 1;
  min-width: 0;
}
.column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.column-header strong {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
}
.column-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}
.detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.detail-item i {
  color: #1890ff;
  font-size: 12px;
}
.detail-item code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  color: #d4380d;
}
.column-sample {
  margin-top: 8px;
  padding: 8px;
  background-color: #fafafa;
  border-left: 3px solid #1890ff;
  border-radius: 4px;
  font-size: 12px;
}
.column-sample .sample-label {
  color: rgba(0, 0, 0, 0.45);
  font-weight: 500;
  margin-right: 8px;
}
.column-sample .sample-value {
  color: #52c41a;
  font-weight: 600;
  background-color: transparent;
}
.selection-summary {
  margin-top: 24px;
  padding: 16px;
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
  border-radius: 8px;
  text-align: center;
}
.selection-summary ::ng-deep .ant-statistic-title {
  color: rgba(255, 255, 255, 0.85);
  font-weight: 600;
}
.selection-summary ::ng-deep .ant-statistic-content {
  color: #ffffff;
  font-size: 32px;
  font-weight: 700;
}
.modal-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
@media (max-width: 768px) {
  .columns-list {
    max-height: 350px;
  }
  .column-details {
    flex-direction: column;
  }
  .detail-item {
    font-size: 12px;
  }
}
/*# sourceMappingURL=smart-column-builder.component.css.map */
